import {ClientEvent} from '@udemy/event-tracking';

export type CLICK_ORIGIN = 'api_reference_sidebar' | 'api_reference_content';
export type MODAL_PAGE = 'modal.client_name' | 'modal.scope_select';

export class DevPortalApiReferenceSelected extends ClientEvent {
    constructor(
        public referenceTarget: string,
        public uiRegion: CLICK_ORIGIN,
    ) {
        super('DevPortalApiReferenceSelected');
    }
}

export class ApiClientCreateCancelled extends ClientEvent {
    constructor(public uiRegion: MODAL_PAGE) {
        super('ApiClientCreateCancelled');
    }
}

export class ApiClientCreated extends ClientEvent {
    constructor(public clientId: string) {
        super('ApiClientCreated');
    }
}

export class ApiClientDeleted extends ClientEvent {
    constructor(public clientId: string) {
        super('ApiClientDeleted');
    }
}

export class ApiClientCredentialsVerified extends ClientEvent {
    constructor(public isValid: boolean) {
        super('ApiClientCredentialsVerified');
    }
}
